import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Success from "../components/Success";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSuccess = () => {
    setShowSuccess(true);
  };

  const handleBackToLogin = () => {
    navigate("/login"); // Navigate to the login page
  };

  return (
    <>
      <Container
        fluid
        className="d-flex justify-content-center align-items-center vh-100"
      >
        <Card className="phone-modal">
          <Card.Body className="phone-modal__body">
            {/* Lock Icon */}
            <div className="text-center mb-3">
              <div className="phone-modal__icon-wrapper">
                <FiLock className="phone-modal__lock-icon" />
              </div>
            </div>

            {/* Title */}
            <h6 className="phone-modal__title">Forgot Password</h6>

            {/* Subtitle */}
            <p className="phone-modal__subtitle">
              Enter your email to reset your password
            </p>

            {/* Phone Input */}
            <Form>
              <Form.Group className="mb-4">
                <Form.Label className="phone-modal__form-label">
                  Email or username
                </Form.Label>

                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <div className="d-flex gap-3">
                <Button
                  variant="outline-secondary"
                  className="flex-grow-1"
                  onClick={handleBackToLogin}
                  // onClick={onCancel}
                >
                  Back to Login
                </Button>
                <Button
                  variant="primary"
                  className="flex-grow-1"
                  onClick={handleSuccess}
                >
                  Send Email
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <Success
        show={showSuccess}
        close={() => setShowSuccess(false)}
        message={`A password reset link has been sent to Email`}
      />
    </>
  );
};

export default ForgotPassword;
